<template>
    <div class="custom-control custom-radio">
        <input
            type="radio"
            class="custom-control-input"
            :name="name"
            :value="data.value"
            :id="id"
            :required="required"
            :disabled="disabled"
            v-model="localValue"
        />
        <label class="custom-control-label cursor-pointer" :for="id">{{
            data.label
        }}</label>
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        required: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            require: true
        },
        name: {
            type: String,
            require: true
        },
        value: {
            type: [String, Number, Boolean],
            require: true
        },
        id: {
            type: String,
            require: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('change', value)
            }
        }
    }
}
</script>
